module.exports = __webpack_public_path__ + "img/order-bg.b45f165a.jpg";